<template>
  <div class="vacation-budget-select">
    <vue-slider
      v-model="budget"
      :min="parseInt(min_budget)"
      :max="parseInt(max_budget)"
      :direction="'btt'"
      :height="250"
      :tooltip="'always'"
      :tooltip-formatter="formatter2"
    ></vue-slider>

    <div class="find-vacation-btn">
      <button
        ref="searchVacationBtn"
        @click="searchVacation"
        class="find-vacation"
      >
        {{ $t("קדימה לחופשה שלי") }}
      </button>
    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    VueSlider
  },
  props: ["min_budget", "max_budget"],
  data() {
    return {
      siteData: window.siteData,
      valMin: parseInt(this.min_budget),
      valMax: parseInt(this.max_budget),
      budget: [siteData.min_budget, siteData.max_budget],
      formatter2: v => `${("" + v).replace(/\B(?=(\d{3})+(?!\d))/g, ",")} €`
    };
  },
  created() {
    window.eventBus.$emit("budgetChange", this.min_budget);
  },
  watch: {
    budget(newValue) {
      window.eventBus.$emit("budgetChange", newValue);
    }
  },
  methods: {
    searchVacation() {
      window.eventBus.$emit("searchVacation", this.$refs.searchVacationBtn);
    }
  }
};
</script>
